  <template>
  <div class="order_container">
    <div class="order_profile clearfix" style="height: auto; padding: 15px 0">
      <div class="order_list">
        <div class="order_list_title">任务名称：</div>
        <div class="order_list_con">{{ selectRow.orderName }}</div>
      </div>
      <div class="order_list">
        <div class="order_list_title">订单编号：</div>
        <div class="order_list_con">{{ selectRow.orderNumber }}</div>
      </div>
      <div class="order_list">
        <div class="order_list_title">发布时间：</div>
        <div class="order_list_con">{{ parseTime(selectRow.releaseTime) }}</div>
      </div>
      <div class="order_list">
        <div class="order_list_title">交付时间：</div>
        <div class="order_list_con">
          {{ parseTime(selectRow.deliveryTime) }}
        </div>
      </div>
      <div class="order_list">
        <div class="order_list_title">订单状态：</div>
        <div class="order_list_con">
          {{ getDictMapItem("order_status", selectRow.orderStatus).label }}
        </div>
      </div>

      <div class="order_list">
        <div class="order_list_title">供应商完成凭证：</div>
        <div class="order_list_con" />
      </div>

      <div class="order_list">
        <div class="order_list_title">供应商实收金额：</div>
        <div class="order_list_con">
          {{ Number(selectRow.settlementPrice).toFixed(2) }}
        </div>
      </div>
      <div class="order_list">
        <div class="order_list_title">应发供应商绩效（含税金）：</div>
        <div class="order_list_con">
          {{ Number(selectRow.performanceFees).toFixed(2) }}
        </div>
      </div>
      <div v-if="checkPermission(['YUMIENTERPRISEUSER_ALL'])">
        <div class="order_list">
          <div class="order_list_title">平台运营费 ：</div>
          <div class="order_list_con">
            {{
              (selectRow.performanceFees * selectRow.orderCoefficient).toFixed(
                2
              )
            }}
          </div>
        </div>
        <div class="order_list">
          <div class="order_list_title">企业应发绩效费（含税金）：</div>
          <div class="order_list_con">
            {{
              (
                Number(selectRow.performanceFees) +
                Number(selectRow.performanceFees) *
                  Number(selectRow.orderCoefficient)
              ).toFixed(2)
            }}
          </div>
        </div>
        <div class="order_list">
          <div class="order_list_title">总付款：</div>
          <div class="order_list_con">
            {{
              (
                Number(selectRow.performanceFees) +
                Number(selectRow.performanceFees) *
                  Number(selectRow.orderCoefficient)
              ).toFixed(2)
            }}
          </div>
        </div>
      </div>
    </div>
    <div class="orderdetail_container">
      <div class="orderdetail_ul">
        <label class="title_label">需求</label>
        <div style="margin: 20px 0; line-height: 21px; text-indent: 29px">
          {{ selectRow.orderDescribe }}
        </div>
      </div>
      <div class="orderdetail_ul">
        <label class="title_label">供应商</label>
        <div class="orderdetail_supplier clearfix">
          <!--<div class="or_sup_img orderdetail-img fl"><img src="/static/home/images/index/pro-li-img1.png"></div>-->
          <div class="or_pro_rg fl" style="height: auto">
            <div>
              <h3>
                <p>
                  供应商：<label>{{
                    selectRow.yumiSupplier
                      ? selectRow.yumiSupplier.supplierName
                      : ""
                  }}</label>
                </p>
              </h3>
              <h3>
                <p style="padding: 5px 0">
                  接单时间：<label>{{
                    parseTime(selectRow.releaseTime)
                  }}</label>
                </p>
              </h3>
              <h3>
                <p style="padding: 5px 0">
                  完成时间：<label>{{
                    parseTime(selectRow.deliveryTime)
                  }}</label>
                </p>
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
      <script>
import initDict from "../../../mixins/initDict";
import { parseTime } from "../../../utils";
import { checkPermission } from "../../../utils/permission";

export default {
  mixins: [initDict],
  props: {
    selectRow: Object,
  },
  created() {
    this.$nextTick(() => {
      this.getDictMap("order_status");
    });
  },
  methods: {
    parseTime,
    checkPermission,
  },
};
</script>
      <style>
.order_container {
  padding: 0 20px;
  padding-top: 0px;
  padding-right: 20px;
  padding-bottom: 0px;
  padding-left: 20px;
}

.order_list {
  font-size: 18px;
  color: #333;
  display: flex;
  padding: 5px 0;
}

.orderdetail_ul .title_label {
  font-size: 18px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 22px;
  height: 22px;
  border-left: 6px solid #3c84ec;
  padding-left: 8px;
}
</style>